export const ON_HOLD_COMMENT_ERROR = 'Comment is required field';
